<div class="relative w-full h-screen bg-white overflow-hidden">
  <div class="wave-container" aria-hidden="true">
    <div class="wave wave-blue">
      <div *ngFor="let i of [0, 1, 2]; let index = index"
           class="wave-segment blue-segment-{{i + 1}}"
           [ngStyle]="getSegmentStyle('blue', i)"
           #waveSegment>
      </div>
    </div>
    <div class="wave wave-green">
      <div *ngFor="let i of [0, 1, 2]; let index = index"
           class="wave-segment green-segment-{{i + 1}}"
           [ngStyle]="getSegmentStyle('green', i)"
           #waveSegment>
      </div>
    </div>
    <div class="wave wave-purple">
      <div class="wave-segment purple-segment-1"
           [ngStyle]="getSegmentStyle('purple', 0)"
           #waveSegment>
      </div>
    </div>
  </div>
</div>
